import { Search, Square } from "lucide-react";
import { type KeyboardEvent } from "react";
import { Button } from "@web/components/ui/button";
import { Input } from "@web/components/ui/input";

export function SearchToolbar({
  busy,
  hasResults,
  message,
  query,
  resultCount,
  searching,
  userAvailable,
  onQueryChange,
  onSearch,
  onStopSearch,
}: {
  busy: boolean;
  hasResults: boolean;
  message: string;
  query: string;
  resultCount: number;
  searching: boolean;
  userAvailable: boolean;
  onQueryChange: (value: string) => void;
  onSearch: () => void;
  onStopSearch: () => void;
}) {
  function handleKeyDown(event: KeyboardEvent<HTMLInputElement>) {
    if (event.key !== "Enter") return;
    event.preventDefault();

    if (searching) {
      onStopSearch();
      return;
    }

    onSearch();
  }

  return (
    <section className="space-y-2">
      <div className="flex items-center justify-between gap-3">
        <p className="text-xs text-muted-foreground">{message}</p>
        {hasResults && <span className="text-xs text-muted-foreground">{resultCount} 条结果</span>}
      </div>

      <div className="flex gap-2">
        <Input
          id="search-books"
          name="search-books"
          value={query}
          onChange={event => onQueryChange(event.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="输入书名或作者"
        />
        {searching ? (
          <Button type="button" variant="secondary" onClick={onStopSearch}>
            <Square className="size-4" />
            停止
          </Button>
        ) : (
          <Button type="button" disabled={busy || !userAvailable} onClick={onSearch}>
            <Search className="size-4" />
            搜索
          </Button>
        )}
      </div>

      {searching && <SearchScanningHint />}
    </section>
  );
}

function SearchScanningHint() {
  return (
    <div className="flex items-center py-2 animate-in fade-in slide-in-from-top-1">
      <span className="relative h-px flex-1 overflow-hidden bg-border">
        {/* 逐个书源检索时只保留一条轻量扫描线 避免占用结果列表空间 */}
        <span className="absolute top-1/2 left-0 h-0.5 w-1/5 -translate-y-1/2 bg-foreground/70 shadow-[0_0_10px_rgba(0,0,0,0.18)] motion-safe:animate-[search-scan_3s_ease-in-out_infinite]" />
      </span>
    </div>
  );
}
